import React, { useEffect, useState } from "react";
import { Col, Form, Row, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import {
    numberFormat,
    refreshPage,
    toastStyle,
    getType,
    getTodayDateISO,
    dateFormat
} from "../../../Helpers/Utils/Common";
import { searchExpenses, updateExpenseStatus } from "../../../Helpers/apiCalls/Reports/DailyExpensesApi";
import { CSVLink } from "react-csv";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import { searchCashCount } from "../../../Helpers/apiCalls/Reports/DailyCashCountApi";
import Footer from "../../../Components/Footer/Footer";

export default function ViewCashCountByShift() {
    const { id, shop } = useParams();
    const { state } = useLocation();
    let navigate = useNavigate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        branch_id: id,
        group_cash_counts_by_branch: 0,
        group_cash_counts_by_cashier: 0,
        group_cash_counts_by_date: 0,
        date_from: state?.date,
        date_to: state?.date,
    })
    const [showLoader, setShowLoader] = useState(false);
    const [expenses, setExpenses] = useState([]);
    const [totalAmount, setTotalAmount] = useState("");
    const [branchName, setBranchName] = useState("");
    const [expenseDate, setExpenseDate] = useState("");
    const [selectedRow, setSelectedRow] = useState([]);
    const [selectedRowItem, setSelectedRowItem] = useState([]);

     /* delete modal handler */
     const [showReviewModal, setShowReviewModal] = useState(false);
     const handleShowReviewModal = () => setShowReviewModal(true);
     const handleCloseReviewModal = () => setShowReviewModal(false);

    const excelHeaders = [
        { label: "Item", key: "name" },
        { label: "Quantity", key: "qty" },
        { label: "Unit", key: "unit" },
        { label: "Unit Price", key: "price" },
        { label: "Amount", key: "total" },
        { label: "Status", key: "status" },
        { label: "Approved By", key: "approved_by_name" },
        { label: "Time Added", key: "added_on" },
        { label: "Store", key: "store" },
    ];

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    function ViewBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => handlePrint(row.id)}
            >
                View
            </button>
        );
    }

    function handlePrint(id) {
        navigate('/dailycashcount/view/' + id,'_blank')
    }

    function handleSelectChange(e, row) {
        setSelectedRow(row);
        setSelectedRowItem(row.expense_item[0]);
        
        if (e.target.value === "review") {
            handleShowReviewModal()
        }
    }
    
    
    function ActionBtn(row, type) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action"
                onChange={(e) => handleSelectChange(e, row)}
            >
                <option value="" hidden selected>
                    Select
                </option>
                { accountType === "admin" ? (
                    <option value="review" className="color-options">
                        Review
                    </option>
                    ): null
                }
            </Form.Select>
        );
    }

    // async function fetchData() {
    //     setShowLoader(true);
    //     setExpenses([])
    //     setExpensesItems([])
    //     var expenseItem = []

    //     if(shop === "braddex") {
    //         const response = await searchExpenses(filterConfig);
    
    //         if (response.error) {
    //         } else {
    //             setBranchName(response.data.data[0].branch_name);
    //             setExpenseDate(response.data.data[0].expense_date)
    //             var expense = response.data.data.map((data) => {
    //                 var info = data;
    //                 info.grand_total = numberFormat(data.grand_total)
    //                 return info;
    //             });
    //             response.data.data.map((data) => {
    //                 data.expense_item.map((item) => {
    //                     var info = item;
    //                     info.store = expense[0].store_name;
    //                     info.qty = numberFormat(item.qty)
    //                     info.price = numberFormat(item.price)
    //                     info.total = numberFormat(item.total)
    //                     info.added_on = new Date(item.added_on).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
    //                     info.approved_by_name = data.approved_by_name;
    //                     expenseItem.push(info)
    //                     // return info;
    //                 });
    //             });
    //             setExpenses(expense)
    //             setExpensesItems(expenseItem)
    
    //             var total = response.data.total_expense? response.data.total_expense : "0";
    //             setTotalAmount(total);
    //         }
    //         setShowLoader(false);
    //     } 
    // }

    async function fetchData() {
        setShowLoader(true);
        setExpenses([])

        const response = await searchCashCount(filterConfig);
        
        if (response.data) {
            var allBills = response.data.cash_counts.map((bill) => {
                
                var info = bill;
                info.count_date = dateFormat(bill.count_date)
                info.amount = numberFormat(bill.physical_count);
                info.change_funds = bill.change_funds ? numberFormat(bill.change_funds) : "";
                info.system_cash_amount = bill.system_cash_amount ? numberFormat(bill.system_cash_amount) : "0.00";
                info.cash_variance = bill.cash_variance ? numberFormat(bill.cash_variance) : "0.00";
                return info;
            });
            setExpenses(allBills)
        }
        setShowLoader(false); 
    }

    

    async function handleChangeExpenseStatus(status) {
        if(shop === "braddex") {
            const response = await updateExpenseStatus(selectedRow.id, status);
            
            if (response.error) {
                toast.error(response.error.response.data.messages.error, {
                    style: toastStyle(),
                });
            } else {
                toast.success("Successfully Updated Cash Advance Status!", {
                    style: toastStyle(),
                });
                setTimeout(() => {
                    refreshPage()
                }, 1000);
            }
        } 
    }

    // React.useEffect(() => {
    //     fetchFranchisee();
    // }, []);

    useEffect(() => {
        fetchData();
    }, [filterConfig]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"DS REPORTS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={6}>
                        <h1 className="page-title"> {branchName} </h1>
                    </Col>
                    {/* <Col className="d-flex justify-content-end">
                        <input
                            type="text"
                            name="item_name"
                            placeholder="Search item name"
                            className="search-bar"
                            onChange={handleOnSearch}
                        ></input>
                    </Col> */}
                </Row>
                <Row className="mb-4">
                    <Col xs={6}>
                        <h5 className="page-subtitle"> {new Date(expenseDate).toLocaleDateString( "en-us", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} </h5>
                    </Col>
                    <Col className="d-flex justify-content-end">
                        <h1 className="page-title green"> TOTAL: {numberFormat(totalAmount)} </h1>
                    </Col>
                </Row>

                {/* <Row  className="d-flex justify-content-end mb-4">
                    <Col xs={6} md={4} lg={3}  className="d-flex justify-content-end">
                        <CSVLink
                            className="button-primary p-3 justify-content-center align-items-center download-csv"
                            data={expensesItems.reverse()}
                            headers={excelHeaders}
                            target="_blank"
                            filename={`${getTodayDateISO()} DailyExpenses_${branchName}`}
                        >
                            <span className="me-2">
                                <img
                                    width={20}
                                    height={20}
                                    src={downloadIcon}
                                    alt=""
                                ></img>
                            </span>
                            Download Excel
                        </CSVLink>
                    </Col>
                </Row> */}

                <div className="tab-content">
                    <div className="my-2 px-2 PO-filters d-flex">
                        <span className="me-2 align-middle mt-2 ps-label">
                            Filter By:
                        </span>
                        <Form.Select
                            name="status"
                            className="date-filter me-2"
                            onChange={(e) => handleOnSearch(e)}
                        >
                            <option value="" selected disabled>
                                Status
                            </option>
                            <option value="">All</option>
                            <option value="pending">Pending</option>
                            <option value="pproved">Approved</option>
                            <option value="disapproved">Disapproved</option>
                        </Form.Select>
                    </div>

                    <div className="below">
                        {/* table */}
                        <Table
                            tableHeaders={[
                                "-",
                                "STORE",
                                "CASHIER",
                                "SHIFT",
                                "DEPOSITED AMT",
                                "CHANGE FUNDS",
                                "REVIEWED BY",
                                // "ACTIONS",
                            ]}
                            headerSelector={[
                                "-",
                                "branch_name",
                                "prepared_by_name",
                                "shift",
                                "amount",
                                "change_funds",
                                "reviewed_by_name",
                            ]}
                            tableData={expenses}
                            ViewBtn={(row) => ViewBtn(row)}
                            // ActionBtn={(row) => ActionBtn(row)}
                            showLoader={showLoader}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
                
                <div className="d-flex justify-content-end pt-2 mb-3">
                <Col xs={4} md={3} lg={3}>
                    <button
                        name="action"
                        className="p-2 button-primary justify-content-center align-items-center close-btn"
                        onClick={() => navigate(-1)}
                    >
                        Close
                    </button>
                    </Col>
                </div>
            </div>
            
            <Footer/>
        </div>
    );
}
